import { httpClient, toClientApiError } from "./httpClient";

async function wrap<T>(fn: () => Promise<T>): Promise<T> {
  try {
    return await fn();
  } catch (error) {
    throw toClientApiError(error);
  }
}

/* ── recycle bin (ADR-0032) ── */
export type RecycleKind = "task" | "automation" | "form" | "form_intake";
export type RecycleEntryDto = {
  id: string;
  kind: RecycleKind;
  kindTitle: string;
  label: string;
  deletedAt: string;
  deletedBy: string | null;
  purgeAfter: string;
};

export const recycleBinApi = {
  list(): Promise<RecycleEntryDto[]> {
    return wrap(async () => (await httpClient.get<{ items: RecycleEntryDto[] }>("/recycle-bin")).data.items);
  },
  restore(id: string): Promise<{ kind: RecycleKind; entityId: string; path: string }> {
    return wrap(async () => (await httpClient.post<{ item: { kind: RecycleKind; entityId: string; path: string } }>(`/recycle-bin/${id}/restore`, {})).data.item);
  },
  remove(id: string): Promise<void> {
    return wrap(async () => {
      await httpClient.delete(`/recycle-bin/${id}`);
    });
  },
};
